import course from './course';
import plan from './plan';
import student from './student';
import employee from './employee';
import chat from './chat';
import survey from './survey';
import telmessage from './telmessage';

export default {
    course,
    plan,
    student,
    employee,
    chat,
    survey,
    telmessage
}